import React,{useEffect} from 'react';
import gaLogger from 'src/utils/ga-logger';
import Slider, { Settings }  from 'react-slick';
import { SlickCarouselProps } from '../typings';
import { checkValue } from 'src/components/common/helper';

export const MediaSlickSlider = (props: SlickCarouselProps) => {
  const { children, settings, gaTracking , exClass="" } = props;

  useEffect(()=>{
    
    if(checkValue(children) && children.length > 3){
      const handleWindowResize = () => {
        setFinalStatus(1);      
      }
      
      handleWindowResize();
  
      window.addEventListener('resize', handleWindowResize);          
  
      return () => {
        window.removeEventListener('resize', handleWindowResize);
      };
    }else{
      hideSlideStatusLable();
    }

  },[]);

  const isArrowVisible = checkValue(children) && (children.length > 3) ? true : false;
  let slickSettings: Settings = {
    arrows: isArrowVisible,
    infinite: false,
    variableWidth: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    centerPadding: '0px',
    initialSlide: 0,
    lazyLoad: 'progressive',
    dots: false,
    swipe:true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: isArrowVisible,
          slidesToScroll:1,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 575,
        settings: {
          arrows:isArrowVisible,
          slidesToScroll:1,
          slidesToShow: 1,
        },
      },
    ],
  };

  if(checkValue(settings)){
    slickSettings = settings;
  }  

  const setFinalStatus = (updatedCurrentSlide) =>{
    if(checkValue(children) && children.length > 3){
      const slideStatus = document.querySelectorAll(".slide-status");
      if (checkValue(slideStatus)) {
        slideStatus.forEach(element => {
          const finalSlideStatus = updatedCurrentSlide  + ' / ' + parseInt(children.length);  
          element.innerHTML=finalSlideStatus.toString();
        });
      }
    }
  }
  
  const hideSlideStatusLable = () =>{
    const statusLabel = document.getElementById("slide-status-label");
    if(checkValue(statusLabel)) {
      statusLabel.style.display = "none"
    }
  }

  const onSlickChange = (currentSlide: number, nextSlide: number) => {
    
    const updatedCurrentSlide = nextSlide + 1; 
    setFinalStatus(updatedCurrentSlide);
    
    if(checkValue(gaTracking)){
      const { eventCategory, eventAction, eventLabel } = gaTracking;
      gaLogger.logGa(eventCategory, eventAction, eventLabel + updatedCurrentSlide);
    }    
  };

  //slickSettings.afterChange = onSlickChange;
  // After Change event not fired sometimes but beforeChange event works fine  
  slickSettings.beforeChange = (currentSlide: number, nextSlide: number) => { onSlickChange(currentSlide,nextSlide) };
  
  return (
    <div className={`ms-common-media-carousel-module ${exClass}`}>
      <Slider {...slickSettings}>{children}</Slider>
    </div>
  );
};
